<template>
    <v-data-table
        dense
        :headers="headers"
        @update:options="handleOptionsUpdate($event)"
        :server-items-length="length"
        :loading="loading"
        :items="data"
        :options="options"
        disable-sort>

        <template v-slot:[`item.item`]="{item}">
            <v-btn icon @click="handleItemClick(item)">
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
            {{item.item_code}} - {{item.item_name}}
        </template>


        <template v-slot:[`item.quantity`]="{item}">
            <span class="font-weight-bold" :class="{'error--text': item.quantity <= item.min, 'warning--text': item.quantity > item.max, 'success--text': item.quantity < item.max && item.quantity > item.min}">
                <v-icon color="warning" v-if="item.quantity > item.max">mdi-arrow-up</v-icon>
                <v-icon color="error" v-if="item.quantity <= item.min">mdi-arrow-down</v-icon>
                <v-icon color="success" v-if="item.quantity > item.min && item.quantity < item.max">mdi-check</v-icon>
                {{formatNumber(item.quantity)}} {{item.measure_unit}}
            </span>
        </template>

        <template v-slot:[`item.min`]="{item}">
            {{item.min}} {{item.measure_unit}}
        </template>

        <template v-slot:[`item.max`]="{item}">
            {{item.max}} {{item.measure_unit}}
        </template>

        <template v-slot:[`item.actions`]="{item}">
            <v-btn icon @click="handleModify(item)" v-if="hasPermission(perm.warehouse_item.update)">
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
        </template>

    </v-data-table>
</template>

<script>
import permissions from './../../data/permissions';
import { mapActions, mapGetters } from 'vuex'
import { formatNumber } from 'accounting';

export default {
    name: "WarhouseItemList",
    props: {
        warehouseId: {
            type: [String, Number]
        }
    },
    data() {
        return {
            perm: permissions
        }
    },
    computed: {
        headers() {
            return [
                { text: this.$t("item"), value: "item" },
                { text: this.$t("location"), value: "location" },
                { text: this.$t("on_hand_quantity"), value: "quantity" },
                { text: this.$t("min_quantity"), value: "min" },
                { text: this.$t("max_quantity"), value: "max" },
                { text: "", value: "actions" },
            ]
        },
        ...mapGetters("stock/warehouseItem/list", [
            "data", "length", "loading", "params", "options"

        ]),
        ...mapGetters({ 
            hasPermission: 'authentication/hasPermission', 
        })
    },
    methods: {
        formatNumber,
        ...mapActions({
            updateOptions: "stock/warehouseItem/list/updateOptions",
            updateParams: "stock/warehouseItem/list/updateParams",
        }),
        handleModify(row) {
            this.$router.push({ name: "WarehouseItemEdit", params: { itemId: row.item_id, warehouseId: row.warehouse_id } })
        },
        quantityColor(row) {
            if(row.quantity > row.max) return "warning__text";
            if(row.quantity <= row.min) return "error__text";
            return "primary";
        },
        handleOptionsUpdate(options) {
            console.log(options);
            if(this.params && this.params.warehouse_id) {
                this.updateOptions({...this.options, ...options})
            }
        },
        handleItemClick(row){
            this.$router.push({ name: "ItemDisplay", params: { id: row.item_id } })
        }
    },
    created() {
        if(this.warehouseId) {
            this.updateParams({...this.params, warehouse_id: this.warehouseId })
        }
    }

}
</script>

<style>

</style>